import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';

export default function UpgradeCancel() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div
        style={{
          textAlign: 'center',
          paddingTop: '80px',
          maxWidth: '480px',
          margin: '0 auto',
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="11" stroke="var(--border)" strokeWidth="1.5"/>
            <path d="M15 12H9m0 0l3-3m-3 3l3 3" stroke="var(--text-muted)"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1
          style={{
            fontSize: '22px',
            fontWeight: 500,
            color: 'var(--text-primary)',
            marginBottom: '8px',
          }}
        >
          No worries
        </h1>
        <p
          style={{
            fontSize: '14px',
            color: 'var(--text-secondary)',
            marginBottom: '24px',
            lineHeight: 1.6,
          }}
        >
          You cancelled the upgrade. You're still on the free tier with 3
          rewrites per day.
        </p>
        <button
          onClick={() => navigate('/editor')}
          style={{
            background: 'var(--btn-primary-bg)',
            color: '#fff',
            border: 'none',
            padding: '10px 28px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Back to editor
        </button>
      </div>
    </Layout>
  );
}
